var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":`${_vm.size}px`,"height":`${_vm.size}px`,"viewBox":"0 0 22 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"fill":_vm.color,"d":"M7 13.875L1.75 8.625L0 10.375L7 17.375L22 2.375L20.25 0.625L7 13.875Z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }